(function() {

	var Container = include("PIXI.Container"),
		Texture = include("PIXI.Texture"),
		Sprite = include("PIXI.Sprite"),
		Application = include("springroll.Application"),
		Emitter = include("cloudkid.Emitter");

	var CluePanel = function()
	{
		Container.call(this);

		this.background = null;
		this.backgroundObjects = null;
		this.levelContainer = null;
		this.hintEmitter = null;
		this.hintSparkle = null;
		this.clueEmitter = null;
		this.targetUI = null;
	};

	var p = CluePanel.prototype = Object.create(Container.prototype);

	p.setup = function()
	{
		this.hiddenClueContainer = new Container();
		this.levelContainer = new Container();

		this.targetUI = new heist.TargetLetterUI();
		this.addChild(this.targetUI);
		this.addChild(this.levelContainer);

		this.hintSparkle = new Container();
		this.levelContainer.addChild(this.hintSparkle);
		var gameConfig = Application.instance.config.game;
		var emitterConfig = gameConfig.clueHintEmitter;
		this.hintEmitter = new Emitter(this.hintSparkle,
									[Texture.fromFrame("SmallStar")],
									emitterConfig);
		this.hintEmitter.emit = false;
		emitterConfig = gameConfig.clueSparkle;
		this.clueEmitter = new Emitter(this.levelContainer,
									[Texture.fromFrame("SmallStar"),
										Texture.fromFrame("SmallStarWhite")],
									emitterConfig);
		this.clueEmitter.emit = false;
	};
	
	p.addBackground = function(background)
	{
		this.backgroundObjects = new Sprite(Texture.fromImage(background + "_objects"));
		this.addChildAt(this.backgroundObjects, 0);
		this.addChildAt(this.hiddenClueContainer, 0);
		this.background = new Sprite(Texture.fromImage(background));
		this.addChildAt(this.background, 0);
	};

	p.showHint = function(target)
	{
		this.hintSparkle.position.x = target.position.x;
		this.hintSparkle.position.y = target.position.y;
		this.hintEmitter.emit = true;
	};

	p.teardown = function()
	{
		if(!this.levelContainer) return;
		
		this.removeChildren();
		this.levelContainer.destroy();
		this.hiddenClueContainer.destroy();
		this.hintSparkle.destroy();
		this.hintEmitter.destroy();
		this.targetUI.destroy();
		this.clueEmitter.destroy();
		this.background.destroy();
		this.backgroundObjects.destroy();
		this.backgroundObjects = this.background = this.hintEmitter = this.targetUI =
			this.clueEmitter = this.hiddenClueContainer = this.levelContainer =
			this.hintSparkle = null;
	};

	namespace('heist').CluePanel = CluePanel;
}());